<template>
  <div id="wording-type">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex sm4 xs12>
          <div class="headline">Wording Type</div>
        </v-flex>
        <v-flex sm3 xs6>
          <!-- <v-autocomplete
            :items="users"
            clearable
            item-text="phone"
            item-value="phone"
            label="User"
            v-model="searchPhone"
          ></v-autocomplete>-->
        </v-flex>
        <v-flex sm3 xs6>
          <!-- <v-autocomplete
            :items="consultingTopics"
            clearable
            item-text="name"
            item-value="name"
            label="Topic"
            v-model="searchTopic"
          ></v-autocomplete>-->
        </v-flex>

        <v-flex sm2 text-xs-center xs12>
          <WordingTypeDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="states"
            :loading="tableLoading"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.idx }}</td>
                <td>{{ props.item.name || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

import WordingTypeDialog from '@/components/admin/WordingTypeDialog'
export default {
  name: 'wording-type',
  components: {
    WordingTypeDialog
  },
  data() {
    return {
      users: [],
      searchPhone: '',
      searchTopic: '',
      // Table
      tableLoading: false,
      headers: [
        { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Name', align: 'left', value: 'name', width: '400' }
      ]
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.WordingType.data.length === 0 // main fetch
      ? store.dispatch('WordingType/fetch').then(next())
      : next()

    if (store.state.Types.data.length === 0) store.dispatch('Types/fetch')
  },
  computed: {
    states() {
      return this.$store.getters['WordingType/getAll']
    }
  },
  created() {},
  methods: {
    editItem(idx) {
      this.$store.commit('WordingType/UPDATE_DIALOG', true)
      this.$store.commit('WordingType/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
